import Utils from '@utils/utils';
import styles from './index.module.scss';

const SkuSidebar = ({ skuList, activeSku, onSelectSku }) => {
    return (
        <div className={`${styles.ResultsBoxLeft} _beauty_scrollbar`}>
            <div className={styles.taskCountTitle}>{skuList?.length || 0} 组任务</div>
            {skuList?.map((item) => (
                <div
                    key={item.skuId}
                    className={`${styles.ImageItem} ${activeSku === item.skuId ? styles.active : ""}`}
                    onClick={() => onSelectSku(item.skuId)}
                >
                    <img src={Utils.getImgThumbnail(item.cover)} alt="" />
                </div>
            ))}
        </div>
    );
};

export default SkuSidebar;
